import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { Checkbox, CheckboxIndicator, CheckboxLabel } from '../checkbox'
import { HStack } from '../hstack'

export type DataItemProps = {
    label: string
    checked: boolean
    onCheckedChange: (checked: boolean) => void
    isDisabled?: boolean
    value?: string
    dropdown?: React.ReactNode
    className?: string
    testID?: string
}

export const DataItem: React.FC<DataItemProps> = ({
    label,
    checked,
    onCheckedChange,
    isDisabled,
    value,
    dropdown,
    className,
    testID,
}) => (
    <HStack testID={testID} className={twMerge('w-full items-center gap-3', className)}>
        <Checkbox
            value={value ?? label}
            isChecked={checked}
            onChange={onCheckedChange}
            isDisabled={isDisabled}
            aria-label={label}
        >
            <CheckboxIndicator />
            <CheckboxLabel className='font-semiBold'>{label}</CheckboxLabel>
        </Checkbox>
        {dropdown ? <Box className='flex-1'>{dropdown}</Box> : null}
    </HStack>
)
DataItem.displayName = 'DataItem'
